import { IconBaseType } from "@/v2-components/core/icon/type";
import { cn } from "@/libs/utils";

export default function ChevronRightIcon({ className }: IconBaseType) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("w-6 h-6", className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9439 10.9348L10.0516 6L8.99548 7.06523L13.8879 12L8.99548 16.9348L10.0516 18L14.9439 13.0652L16 12L14.9439 10.9348Z"
        fill="currentColor"
      />
    </svg>
  );
}
